import { useCallback, useEffect, useRef } from 'react';
import debounce from 'lodash/debounce';

export const useScrollWatcher = (callback, { deps = [], interval = 100 }) => {
    const scrollListener = useRef(null);
    const position = useRef(0);

    const checkScrollPosition = useCallback(() => {
        callback(position.current);
        position.current = window.pageYOffset;
    }, [callback]);

    useEffect(() => {
        const handleScroll = () => {
            checkScrollPosition();
        };

        const debouncedHandleScroll = debounce(handleScroll, interval);

        scrollListener.current = window.addEventListener(
            'scroll',
            debouncedHandleScroll,
        );

        return window.removeEventListener('scroll', scrollListener.current);
        //eslint-disable-next-line
    }, [...deps, checkScrollPosition, interval]);
};
